import { getBootstrapConfig } from '~src/bootstrap/bootstrap-config';

interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
}

interface GlobalConfig {
  cdnUrl: string;
  googleApiKey: string;
  ingridApiAddr: string;
  mapboxToken: string;
  maptilerToken: string;
  posthogKey: string;
  sentryDsn: string;
  firebaseCollection: string;
  firebaseConfig: FirebaseConfig;
}

/*
 * This config is built-in into the bundle.
 * TODO: Probably it should be called "static config" or something similar.
 */
// @ts-ignore
export const globalConfig = GLOBAL_CONFIG as GlobalConfig;

/*
 * This config is passed from bootstrap.
 *
 * Security: We should pass all the sensitive data via the "hash" part of the
 * url, because this part is not send to the server but is avaiable for
 * browser only inside the iframe.
 */
export const bootstrapConfig = getBootstrapConfig();
